// eslint-disable-next-line spire/fenced-imports
import { format } from "date-fns";

interface Props {
    dateTime: Date | string;
    dateFormat: string;
}

/**
 * This component will return a dateTime based on format provided in props using date-fns library
 */
const getDateTimeFormat = ({ dateTime, dateFormat }: Props) => {
    return format(dateTime, dateFormat);
};

export default getDateTimeFormat;
